import { PATIENT_TYPE_OPTIONS } from '../../constants';
import { getLocationLabelFromState } from '../../core/util/search';
import {
  UNIVERSAL_PLACEHOLDER_IN_MARKET,
  UNIVERSAL_PLACEHOLDER_OUT_OF_MARKET,
} from './Inputs/Universal';
import { profileIsChild } from '../../core/util/account';

export const getUniversalPlaceholder = isInMarketPlaceSearch =>
  isInMarketPlaceSearch ? UNIVERSAL_PLACEHOLDER_IN_MARKET : UNIVERSAL_PLACEHOLDER_OUT_OF_MARKET;

export const getUniversalLabel = (universalSearch, isInMarketPlaceSearch) => {
  const inputQuery = universalSearch.displayQuery;
  const universalPlaceholder = getUniversalPlaceholder(isInMarketPlaceSearch);

  return {
    inputValue: inputQuery || universalPlaceholder,
    isPlaceholder: !inputQuery,
  };
};

export const getLocationLabel = (position, searchPreferences) => {
  const defaultLabel = 'City, State, or Zip';
  const inputValue = getLocationLabelFromState({
    position,
    searchPreferences,
    defaultLabel,
  });
  return {
    inputValue: inputValue || defaultLabel,
    isPlaceholder: inputValue === defaultLabel,
  };
};

export const getTimeLabel = newBooking => {
  const inputValue =
    newBooking.booking &&
    newBooking.booking.requestedAppointmentTime &&
    newBooking.booking.requestedAppointmentTime.timeLabel;
  return { inputValue: inputValue || 'ASAP' };
};

export const getPatientLabel = newBooking => {
  let inputValue =
    newBooking.booking && newBooking.booking.patientType && newBooking.booking.patientType.label;
  if (newBooking.profile && profileIsChild(newBooking.profile)) {
    inputValue = PATIENT_TYPE_OPTIONS[1].label; /* PATIENT_TYPE_KIDS */
  }
  return { inputValue: inputValue || PATIENT_TYPE_OPTIONS[0].label };
};

export const getInsuranceCarrierLabel = searchPreferences => {
  const inputValue =
    searchPreferences.requestedInsurance && searchPreferences.requestedInsurance.display_name;
  return { inputValue: inputValue || 'Select insurance' };
};
